export default __webpack_public_path__ + "static/esg-chart-mobile-b79599899987ff26fb2ee4c09708ba2d.png";